import React, { useState } from 'react'

import PropTypes from 'prop-types'

import useCanManageApplications from '../../useCanManageApplications'
import CollapsingCard from './CollapsingCard'
import CompletedStep from './CompletedStep'
import StepHeader from './StepHeader'
import Success from './Success'

const Step = ({
  stepHeader,
  cardHeader,
  successMessage,
  refetchAppConfig,
  isActive,
  isComplete,
  renderStep,
  secondarySuccessMessage,
}) => {
  const [showSuccess, setShowSuccess] = useState(isComplete)
  const [collapse, setCollapse] = useState(false)
  const canCompleteStep = useCanManageApplications()
  const completeStep = () => {
    setShowSuccess(true)
    setTimeout(() => setCollapse(true), 3500)
  }

  return (
    <React.Fragment>
      <StepHeader title={stepHeader} />
      {isComplete ? (
        <CompletedStep
          title={cardHeader}
          readonly={!canCompleteStep}
        />
      ) : (
        <CollapsingCard
          title={cardHeader}
          isExpanded={isActive && !collapse}
          readonly={!canCompleteStep}
          onExited={refetchAppConfig}
        >
          {showSuccess ? (
            <Success
              message={successMessage}
              secondaryMessage={secondarySuccessMessage}
              success={showSuccess}
            />
          ) : (
            renderStep({ completeStep, isActive })
          )}
        </CollapsingCard>
      )}
    </React.Fragment>
  )
}

Step.propTypes = {
  stepHeader: PropTypes.string.isRequired,
  cardHeader: PropTypes.string.isRequired,
  successMessage: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired,
  refetchAppConfig: PropTypes.func.isRequired,
  renderStep: PropTypes.any.isRequired,
  secondarySuccessMessage: PropTypes.string,
}

export default Step
